import React from 'react';
import './LoginModal.scss';
import Sheet from 'components/redesign/Sheet';
import useIsMobile from 'components/redesign/Sheet/useViewport';
import MorphDialog from 'components/redesign/MorphDialog';

interface LoginModalProps {
    open: boolean;
    onCancel: () => void;
    header: React.ReactNode;
    subHeader: React.ReactNode;
    form: React.ReactElement;
}
function LoginModalContent({
    header,
    subHeader,
    form,
}: Pick<LoginModalProps, 'header' | 'subHeader' | 'form'>): React.ReactElement {
    return (
        <div className="rd-login">
            <div className="rd-login__head">
                <h2 className="rd-login__title">{header}</h2>
                <p className="rd-login__sub">{subHeader}</p>
            </div>
            {form}
        </div>
    );
}
function LoginModal({
    open,
    onCancel,
    header,
    subHeader,
    form,
}: LoginModalProps): React.ReactElement {
    const isMobile = useIsMobile();
    const content = (
        <LoginModalContent header={header} subHeader={subHeader} form={form} />
    );

    if (isMobile) {
        return (
            <Sheet open={open} onClose={onCancel} ariaLabel="Вход в систему">
                {content}
            </Sheet>
        );
    }

    return (
        <MorphDialog
            open={open}
            onClose={onCancel}
            ariaLabel="Вход в систему"
            className="rd-dialog--login"
        >
            {content}
        </MorphDialog>
    );
}

export default React.memo(LoginModal);
